if (!customElements.get('home-product-explorer')) {
  class HomeProductExplorer extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-explorer-tab]')];
      this.panels = [...this.querySelectorAll('[data-explorer-panel]')];
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.explorerTab, true));
        tab.addEventListener('keydown', (event) => this.onKeydown(event));
      });
    }

    select(name, focus = false) {
      this.tabs.forEach((tab) => {
        const selected = tab.dataset.explorerTab === name;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        if (selected && focus) tab.focus();
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.explorerPanel !== name;
      });
    }

    onKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let nextIndex = null;
      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex === null) return;
      event.preventDefault();
      this.select(this.tabs[nextIndex].dataset.explorerTab, true);
    }
  }

  customElements.define('home-product-explorer', HomeProductExplorer);
}
